import { IObservable, Subject } from '~/rage/utils';
import {
	IVehicleMarketAdvertBase,
	IVehicleMarketAdvertDetails,
	TechTuningCategory,
	TechTuningRarity,
	VehicleNumberPlateType,
} from '~/shared';
import { IVehicleMarketService } from './vehicleMarketServiceTypes';

export class VehicleMarketServiceStub implements IVehicleMarketService {
	private vehicleAdvertPrice = new Subject<number>(20000);
	private maxSellTimeMs = new Subject<number>(60 * 60 * 1000);
	private currentAdvert = new Subject<
		(IVehicleMarketAdvertBase & IVehicleMarketAdvertDetails) | null
	>({
		vehicleId: '0',
		price: 10_000_000,
		expiresAt: Date.now() + 10 * 60 * 1000,
		numberPlate: {
			type: VehicleNumberPlateType.Classic,
			text: 'A123AA',
			region: '138',
		},
		vehicleModel: 'toy25',
		ownerNickname: 'IMineev1',
		mileage: 10_000,
		ownersCount: 2,
		tuning: [
			{
				category: TechTuningCategory.ENGINE,
				level: 5,
				rarity: TechTuningRarity.LEGENDARY,
			},
			{
				category: TechTuningCategory.TURBO,
				level: 1,
				rarity: TechTuningRarity.COMMON,
			},
			{
				category: TechTuningCategory.EXHAUST,
				level: 2,
				rarity: TechTuningRarity.UNCOMMON,
			},
			{
				category: TechTuningCategory.RADIATOR,
				level: 3,
				rarity: TechTuningRarity.RARE,
			},
			{
				category: TechTuningCategory.STARTER,
				level: 4,
				rarity: TechTuningRarity.EPIC,
			},
			{ category: TechTuningCategory.BRAKES, level: null, rarity: null },
			{
				category: TechTuningCategory.SUSPENSION,
				level: 2,
				rarity: TechTuningRarity.UNCOMMON,
			},
			{ category: TechTuningCategory.TIRES, level: null, rarity: null },
		],
	});

	public getCurrentAdvert(): IObservable<
		(IVehicleMarketAdvertBase & IVehicleMarketAdvertDetails) | null
	> {
		return this.currentAdvert;
	}

	public async createAdvert(price: number): Promise<void> {
		this.currentAdvert.next({
			...(this.currentAdvert.getValue() as IVehicleMarketAdvertBase &
				IVehicleMarketAdvertDetails),
			price: price,
		});
		console.log('createAdvert', { price });
	}

	public async editAdvertPrice(
		vehicleId: string,
		newPrice: number,
	): Promise<void> {
		this.currentAdvert.next({
			...(this.currentAdvert.getValue() as IVehicleMarketAdvertBase &
				IVehicleMarketAdvertDetails),
			price: newPrice,
		});
		console.log('updateAdvert', {
			vehicleId,
			newPrice,
		});
	}

	public async removeAdvert(vehicleId: string): Promise<void> {
		console.log('removeAdvert', {
			vehicleId,
		});
	}

	public async buyAdvert(vehicleId: string): Promise<void> {
		console.log('purchaseAdvert', {
			vehicleId,
		});
	}

	public getVehicleAdvertPrice(): IObservable<number> {
		return this.vehicleAdvertPrice;
	}

	public getMaxSellTimeMs(): IObservable<number> {
		return this.maxSellTimeMs;
	}

	public getIsCreatingNewAdvert(): IObservable<boolean> {
		return new Subject<boolean>(false);
	}

	public async exitMenu(): Promise<void> {
		console.log('vehicleMarket:exitMenu');
	}
}
